import {
  deleteCorporateClientCredential,
  distributeCorporateCredits,
  findCorporateClientCredential,
  getCorporateCreditsDistributionSchedules,
  getCorporateDetail,
  getPaginatedCorporateMembersByCorporateId,
} from '../../../api/corporateApi'
import BatchDistributeCreditsModal from '../../../components/corporates/batch-distribute-credits-modal/batch-distribute-credits-modal'
import CorporateClientCredentialModal from '../../../components/corporates/corporate-client-credential-modal/corporate-client-credential-modal'
import CorporateCreditsDistributionScheduleTable from '../../../components/corporates/corporate-credits-distribution-schedule-table/corporate-credits-distribution-schedule-table'
import CorporateCreditsModal from '../../../components/corporates/corporate-credits-modal/corporate-credits-modal'
import CorporateDescriptions from '../../../components/corporates/corporate-descriptions/corporate-descriptions'
import CorporateLocations from '../../../components/corporates/corporate-locations/corporate-locations'
import CorporateUnusedDistributedCreditsModal from '../../../components/corporates/corporate-unused-distributed-credits-modal/corporate-unused-distributed-credits-modal'
import CreateCorporateCreditsDistributionScheduleModal from '../../../components/corporates/create-corporate-credits-dirtibution-schedule-modal/create-corporate-credits-dirtibution-schedule-modal'
import DistributeCreditsModal from '../../../components/corporates/distribute-credits-modal/distribute-credits-modal'
import { getSearchValues } from '../../../helpers/utils'
import translate from '../../../i18n'
import { PageInfo } from '../../../share-types'
import CorporateMembers from '../corporate-members/corporate-members'
import {
  CorporateCreditsRequest,
  ICorporateClientCredential,
  ICorporateCreditsDistributionSchedule,
  ICorporateCreditsDistributionScheduleFilterParams,
  ICorporateDetailResponse,
  ICorporateMember,
  ICorporatesFilterParams,
  IPaginatedCorporateCreditsDistributionScheduleFilterParams,
  IPaginatedCorporateMembersParams,
} from '../share-type'
import styles from './corporate.module.less'
import { Space, notification, Modal } from 'antd'
import * as _ from 'lodash'
import React, { useEffect, useState } from 'react'
import { useParams, useSearchParams } from 'react-router-dom'

const defaultPage = {
  pageSize: 10,
  currentPage: 1,
  count: 0,
}
const Corporate = () => {
  const params = useParams()
  const [corporateId] = useState<number | undefined>(Number(params?.id))
  const [corporate, setCorporate] = useState<ICorporateDetailResponse>()
  const [corporateClientCredential, setCorporateClientCredential] =
    useState<ICorporateClientCredential>()

  const [corporateMembers, setCorporateMembers] = useState<ICorporateMember[]>([])
  const [pageInfo, setPageInfo] = useState<PageInfo>(defaultPage)
  const [corporateCreditsDistributionSchedules, setCorporateCreditsDistributionSchedules] =
    useState<ICorporateCreditsDistributionSchedule[]>([])
  const [creditsDistributionSchedulePageInfo, setCreditsDistributionSchedulePageInfo] =
    useState<PageInfo>(defaultPage)
  const [creditsDistributionScheduleSearchValues, setCreditsDistributionScheduleSearchValues] =
    useState<ICorporateCreditsDistributionScheduleFilterParams>()

  const [searchValues, setSearchValues] = useState<ICorporatesFilterParams>()
  const [searchParams, setSearchParams] = useSearchParams()

  const [adjustmentCorporateVisible, setAdjustmentCorporateVisible] = useState<boolean>(false)
  const [adjustUnusedDistributedCreditsVisible, setAdjustUnusedDistributedCreditsVisible] =
    useState<boolean>(false)

  const [openBatchDistributeCreditsModal, setOpenBatchDistributeCreditsModal] =
    useState<boolean>(false)

  const [
    openCreateCorporateDistributionScheduleModal,
    setOpenCreateCorporateDistributionScheduleModal,
  ] = useState<boolean>(false)

  const [distributeCreditsModalVisible, setDistributeCreditsModalVisible] = useState<boolean>(false)
  const [distributeCreditsLoading, setDistributeCreditsLoading] = useState<boolean>(false)

  const [editCorporateClientCredentialVisible, setEditCorporateClientCredentialVisible] =
    useState<boolean>(false)

  useEffect(() => {
    getCorporateDetailAction()
    getCorporateClientCredentialAction()
  }, [corporateId])

  useEffect(() => {
    const newSearchValues = getSearchValues(
      [
        { key: 'phoneNumber', isBoolean: false },
        { key: 'isActive', isBoolean: true },
        { key: 'expiredStartDate', isBoolean: false },
        { key: 'expiredEndDate', isBoolean: false },
        { key: 'size', isBoolean: false, default: defaultPage.pageSize },
        { key: 'page', isBoolean: false, default: defaultPage.currentPage - 1 },
      ],
      searchParams,
    )
    const data = {
      ...newSearchValues,
      size: Number(newSearchValues.size),
      page: Number(newSearchValues.page),
    }
    setSearchValues(newSearchValues)
    getPaginatedCorporateMembersAction(data)
    getCreditsDistributionSchedulesAction({
      size: creditsDistributionSchedulePageInfo.pageSize,
      page: 0,
    })
  }, [])

  const getCorporateClientCredentialAction = () => {
    if (!corporateId) {
      return
    }
    findCorporateClientCredential(corporateId).then(res => {
      setCorporateClientCredential(res)
    })
  }

  const reloadCorporateDetailAndMembers = () => {
    const data = {
      ...searchValues,
      size: pageInfo.pageSize,
      page: 0,
    }
    setSearchParams(getSearchParams(data))
    getPaginatedCorporateMembersAction(data)
    getCorporateDetailAction()
  }

  const reloadCorporateCreditsDistribution = () => {
    const data = {
      ...creditsDistributionScheduleSearchValues,
      size: creditsDistributionSchedulePageInfo.pageSize,
      page: 0,
    }
    getCreditsDistributionSchedulesAction(data)
    getCorporateDetailAction()
  }

  const getPaginatedCorporateMembersAction = (data: IPaginatedCorporateMembersParams) => {
    if (corporateId) {
      getPaginatedCorporateMembersByCorporateId(corporateId, data).then(res => {
        if (res && res.pageInfo && res.data) {
          setPageInfo({
            ...res.pageInfo,
            currentPage: res.pageInfo.currentPage + 1,
          })
          setCorporateMembers(res.data)
        }
      })
    }
  }

  const getCorporateDetailAction = () => {
    if (!corporateId) {
      return
    }
    getCorporateDetail(corporateId).then(res => {
      setCorporate(res)
    })
  }

  const getCreditsDistributionSchedulesAction = (
    data: IPaginatedCorporateCreditsDistributionScheduleFilterParams,
  ) => {
    if (!corporateId) {
      return
    }

    getCorporateCreditsDistributionSchedules(corporateId, data).then(res => {
      if (res && res.pageInfo && res.data) {
        setCreditsDistributionSchedulePageInfo({
          ...res.pageInfo,
          currentPage: res.pageInfo.currentPage + 1,
        })
        setCorporateCreditsDistributionSchedules(res.data)
      }
    })
  }

  const paginationOnChange = (page: number, pageSize: number) => {
    const data = {
      ...searchValues,
      size: pageSize,
      page: page - 1,
    }
    setSearchParams(getSearchParams(data))
    getPaginatedCorporateMembersAction(data)
  }

  const creditsDistributionSchedulePaginationOnChange = (page: number, pageSize: number) => {
    const data = {
      ...searchValues,
      size: pageSize,
      page: page - 1,
    }
    getCreditsDistributionSchedulesAction(data)
  }

  const onSearchCreditsDistributionSchedule = (value: ICorporatesFilterParams) => {
    const data = {
      size: creditsDistributionSchedulePageInfo.pageSize,
      page: 0,
      ...value,
    }
    setCreditsDistributionScheduleSearchValues(value)
    getCreditsDistributionSchedulesAction(data)
  }

  const onSearch = (value: ICorporatesFilterParams) => {
    const data = {
      size: pageInfo.pageSize,
      page: 0,
      ...value,
    }
    setSearchValues(value)
    setSearchParams(getSearchParams(value))
    getPaginatedCorporateMembersAction(data)
  }

  const getSearchParams = (data: any) => {
    return _.pickBy(data, item => item !== undefined)
  }

  const onSubmitAdjustmentCorporate = () => {
    getCorporateDetailAction()
  }

  const onSubmitAdjustUnusedDistributedCredits = () => {
    getCorporateDetailAction()
  }

  const onCancelBatchDistributeCredits = () => {
    setOpenBatchDistributeCreditsModal(false)
  }

  const onSubmitBatchDistributeCredits = () => {
    setOpenBatchDistributeCreditsModal(false)
    reloadCorporateDetailAndMembers()
  }

  const onCancelCreateCorporateCreditsDistributionSchedule = () => {
    setOpenCreateCorporateDistributionScheduleModal(false)
  }

  const onSubmitCreateCorporateCreditsDistributionSchedule = () => {
    setOpenCreateCorporateDistributionScheduleModal(false)
    reloadCorporateCreditsDistribution()
  }

  const onCreditsNotesFormFinish = (value: CorporateCreditsRequest) => {
    if (!corporateId) {
      return
    }
    setDistributeCreditsLoading(true)
    distributeCorporateCredits(corporateId, value)
      .then(() => {
        notification.success({
          message: translate('corporate.credits.distributionSuccess'),
        })
        reloadCorporateDetailAndMembers()
      })
      .catch(err => {
        notification.error({
          message: translate('corporate.credits.distributionFailed'),
          description: err?.message || translate('networkError'),
        })
      })
      .finally(() => {
        setDistributeCreditsLoading(false)
        setDistributeCreditsModalVisible(false)
      })
  }

  const onSubmitEditCorporateCredential = () => {
    getCorporateClientCredentialAction()
  }

  const onDeleteCorporateClientCredential = () => {
    if (!corporate?.corporate.id) {
      return
    }
    Modal.confirm({
      title: translate('corporate.corporateClientCredential.deleteTitle'),
      onOk: () => {
        deleteCorporateClientCredential(corporate?.corporate.id)
          .then(() => {
            notification.success({
              message: translate('corporate.corporateClientCredential'),
              description: translate('corporate.corporateClientCredential.deleteSuccess'),
            })
            getCorporateClientCredentialAction()
          })
          .catch(err => {
            notification.success({
              message: translate('corporate.corporateClientCredential'),
              description:
                err?.message || translate('corporate.corporateClientCredential.deleteFailed'),
            })
          })
      },
    })
  }

  return (
    <>
      <Space className={styles['corprate-desc-wrapper']} orientation="vertical" size={16}>
        {corporate && (
          <CorporateDescriptions
            corporate={corporate}
            corporateClientCredential={corporateClientCredential}
            onEditCorporateClientCredential={() => setEditCorporateClientCredentialVisible(true)}
            onDeleteCorporateClientCredential={() => onDeleteCorporateClientCredential()}
            onAdjustmentCredits={() => setAdjustmentCorporateVisible(true)}
            onAdjustUnusedDistributedCredits={() => setAdjustUnusedDistributedCreditsVisible(true)}
            onDistributeCredits={() => setDistributeCreditsModalVisible(true)}
            onBatchDistributeCredit={() => setOpenBatchDistributeCreditsModal(true)}
            onCreateCorporateDistributionScheduleModal={() =>
              setOpenCreateCorporateDistributionScheduleModal(true)
            }
          />
        )}

        {corporate && <CorporateLocations corporateId={corporate.corporate.id} />}

        {corporate && (
          <CorporateMembers
            corporateId={corporate.corporate.id}
            reloadPageData={reloadCorporateDetailAndMembers}
            corporateMembers={corporateMembers}
            pageInfo={pageInfo}
            paginationOnChange={paginationOnChange}
            onSearch={onSearch}
            searchValues={searchValues}
            isTrialCorporate={corporate.corporate.isTrial}
          />
        )}

        {corporate && (
          <CorporateCreditsDistributionScheduleTable
            corporateId={corporate.corporate.id}
            pageInfo={creditsDistributionSchedulePageInfo}
            paginationOnChange={creditsDistributionSchedulePaginationOnChange}
            schedules={corporateCreditsDistributionSchedules}
            onSearch={onSearchCreditsDistributionSchedule}
            searchValues={creditsDistributionScheduleSearchValues}
          />
        )}
      </Space>

      <DistributeCreditsModal
        open={distributeCreditsModalVisible}
        loading={distributeCreditsLoading}
        onFinish={onCreditsNotesFormFinish}
        handleCancel={() => setDistributeCreditsModalVisible(false)}
        isTrialCorporate={corporate?.corporate.isTrial || false}
      />

      {corporate && (
        <CorporateCreditsModal
          adjustmentCorporate={corporate.corporate}
          visiable={adjustmentCorporateVisible}
          onCancel={() => setAdjustmentCorporateVisible(false)}
          onSubmit={onSubmitAdjustmentCorporate}
        />
      )}

      {corporate && (
        <CorporateUnusedDistributedCreditsModal
          corporate={corporate.corporate}
          visible={adjustUnusedDistributedCreditsVisible}
          onCancel={() => setAdjustUnusedDistributedCreditsVisible(false)}
          onSubmit={onSubmitAdjustUnusedDistributedCredits}
        />
      )}

      {corporate && (
        <BatchDistributeCreditsModal
          corporateId={corporate.corporate.id}
          isTrialCorporate={corporate.corporate.isTrial}
          open={openBatchDistributeCreditsModal}
          handleCancel={onCancelBatchDistributeCredits}
          handleSubmit={onSubmitBatchDistributeCredits}
        />
      )}

      {corporate && (
        <CreateCorporateCreditsDistributionScheduleModal
          corporateId={corporate.corporate.id}
          isTrialCorporate={corporate.corporate.isTrial}
          open={openCreateCorporateDistributionScheduleModal}
          handleCancel={onCancelCreateCorporateCreditsDistributionSchedule}
          handleSubmit={onSubmitCreateCorporateCreditsDistributionSchedule}
        />
      )}

      {corporate && (
        <CorporateClientCredentialModal
          visible={editCorporateClientCredentialVisible}
          corporate={corporate.corporate}
          corporateClientCredential={corporateClientCredential}
          onCancel={() => setEditCorporateClientCredentialVisible(false)}
          onSubmit={onSubmitEditCorporateCredential}
        />
      )}
    </>
  )
}

export default Corporate
